import { Injectable } from '@angular/core';
import { tap, map } from 'rxjs/operators';
import { AngularFireFunctions } from '@angular/fire/functions';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';
import { Observable, forkJoin } from 'rxjs';
import { GetCustomerTransactionsData, GetPaymentMethodsData } from 'functions/src/common/types/payment';

export const firebaseApi = {
  saveStripeAcc: `/fetchStripeUserAndSave`,
  disconnectAcc: `/revokeStripeUser`,
  createCharge: `/createCharge`,
  createTransfers: '/createTransfers',
  createRefunds: '/createRefunds',
  createLoginLink: '/createLoginLink'
};


@Injectable({
  providedIn: 'root'
})
export class FirebaseApiService {

  constructor(
    private httpService: HttpService,
    private fns: AngularFireFunctions) { }


  saveStripeAccount(code, entityId) {
    const queryParams = {
      authorization_code: code,
      entityId
    };
    return this.httpService.get(`https://us-central1-${environment.firebase.projectId} ` +
      `.cloudfunctions.net${firebaseApi.saveStripeAcc}`, queryParams)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  disconnectAccount(client_id, stripe_user_id, entityId) {
    const queryParams = {
      client_id,
      stripe_user_id,
      entityId
    };
    return this.httpService.get(`https://us-central1-${environment.firebase.projectId}.` +
      `cloudfunctions.net${firebaseApi.disconnectAcc}`, queryParams)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  createCharge(amount, source) {
    const queryParams = {
      amount,
      source
    };
    return this.httpService.get(`https://us-central1-${environment.firebase.projectId}.` +
      `cloudfunctions.net${firebaseApi.createCharge}`, queryParams)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  createRefunds(charge, amount) {
    const queryParams = {
      charge,
      amount
    };
    return this.httpService.get(`https://us-central1-${environment.firebase.projectId}. ` +
      `cloudfunctions.net${firebaseApi.createRefunds}`, queryParams)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  proceedRefunds(refunds: any[]): Observable<any> {
    const responses = [];
    for (const refund of refunds) {
      responses.push(this.createRefunds(refund.charge, refund.amount));
    }
    return forkJoin(responses);
  }

  createTransfers(amount, destination, description) {
    const queryParams = {
      amount,
      destination,
      description
    };
    return this.httpService.get(`https://us-central1-${environment.firebase.projectId}.` +
      `cloudfunctions.net${firebaseApi.createTransfers}`, queryParams)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  createLoginLink(stripe_user_id) {
    const queryParams = {
      stripe_user_id
    };
    return this.httpService.get(`https://us-central1-${environment.firebase.projectId}.` +
      `cloudfunctions.net${firebaseApi.createLoginLink}`, queryParams)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getPaymentMethods(data: any): Observable<GetPaymentMethodsData> {
    return this.fns.httpsCallable('getPaymentMethods')(data);
  }

  attachPaymentMethodToCustomer(data: any): Observable<GetPaymentMethodsData> {
    return this.fns.httpsCallable('attachPaymentMethodToCustomer')(data);
  }

  getCustomerPayments(data: any): Observable<GetCustomerTransactionsData> {
    return this.fns.httpsCallable('getCustomerPayments')(data);
  }

  createSubscription(data: any): Observable<any> {
    return this.fns.httpsCallable('createSubscription')(data);
  }

  cancelSubscription(data: any): Observable<any> {
    return this.fns.httpsCallable('cancelSubscription')(data);
  }

  retrieveUpcomingInvoice(data: any): Observable<any> {
    return this.fns.httpsCallable('retrieveUpcomingInvoice')(data);
  }
}
